import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import twentyThree03 from "../../Assets/Logo/2303.jpeg";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";


function NonMayaMerchantInfo({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    non_maya_merchant_type: false,
    registration_type: false,
    registration_photo: false,
  });

  const [isUploading, setIsUploading] = useState(false);

  // Options for the form
  const MAYA_SOLUTION_OPTIONS = ["SQR", "Terminal", "SQR & Terminal", "Not Interested"];
  const REGISTRATION_OPTIONS = ["Sole Proprietorship", "Partnership", "Corporation", "Cooperative"];
  const DISCLOSURE_REASONS = [
    "Owner/OIC cannot disclose",
    "Confidential", 
    "Others"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        registration_photo_temp_path: uploadResult.temp_path
      }));
      if (isError.registration_photo) {
        setIsError(prev => ({ ...prev, registration_photo: false }));
      }
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const validateForm = () => {
    const errors = {
      non_maya_merchant_type: !primaryDetails.non_maya_merchant_type,
    };

    // Only validate registration fields if "Not Interested" is not selected
    if (primaryDetails.non_maya_merchant_type !== "Not Interested") {
      errors.registration_type = !primaryDetails.registration_type;
      // errors.registration_photo = !primaryDetails.registration_photo;
    }

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    if (!primaryDetails.non_maya_merchant_type) {
      return false;
    }

    if (primaryDetails.non_maya_merchant_type !== "Not Interested") {
      return !!primaryDetails.registration_type;
    }

    return true;
  };
  const handleNext = () => {
    if (validateForm()) {
      // Check if "Not Interested" is selected
      if (primaryDetails.non_maya_merchant_type === "Not Interested") {
        console.log("Navigating to not-interested-maya-solution");
        navigation.go("not-interested-maya-solution");
      } else {
        // Navigate to P1 Door Hanger Merchandising (Section 36)
        console.log("Navigating to p1-door-hanger-merchandising");
        navigation.go("terminal-availability");
      }
    } else {
      console.log("Form validation failed");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          {/* Form Content */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">
                  NON MAYA MERCHANT INFORMATION
                </h4>
                <p className="form-desc">
                  Please provide merchant information details
                </p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Maya Solution Type */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      If Yes, what kind of MAYA Solution <span className="form-required">*</span>
                    </Form.Label>

                    <Form.Select
                      name="non_maya_merchant_type"
                      value={primaryDetails.non_maya_merchant_type || ''}
                      onChange={handleInputChange}
                      className={`form-select${isError.non_maya_merchant_type ? ' form-input-error' : ''}`}
                    >
                      <option value="">Select Maya solution type</option>
                      {MAYA_SOLUTION_OPTIONS.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>

                    {isError.non_maya_merchant_type && (
                      <div className="form-error">
                        Please select a Maya solution type
                      </div>
                    )}
                  </Form.Group>

                  {/* Hide these fields when "Not Interested" is selected */}
                  {primaryDetails.non_maya_merchant_type !== "Not Interested" && (
                    <>
                      {/* Type of Registration */}
                      <Form.Group className="mb-4">
                        <Form.Label className="form-label">
                          Type of Registration <span className="form-required">*</span>
                        </Form.Label>

                        <Form.Select
                          name="registration_type"
                          value={primaryDetails.registration_type || ''}
                          onChange={handleInputChange}
                          className={`form-select${isError.registration_type ? ' form-input-error' : ''}`}
                        >
                          <option value="">Select registration type</option>
                          {REGISTRATION_OPTIONS.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))}
                        </Form.Select>

                        {isError.registration_type && (
                          <div className="form-error">
                            Please select a registration type
                          </div>
                        )}
                      </Form.Group>

                      {/* Photo of 2303 */}
                      <Form.Group className="mb-4">
                        <Form.Label className="form-label">
                          Photo of 2303
                          {primaryDetails.registration_photo_temp_path && !isUploading && (
                            <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                          )}
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={handlePhotoUpload}
                          className="mb-2"
                          disabled={isUploading}
                        />
                        {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                        <div className="sample-photo-container">
                          <p className="form-note-text mb-2">
                            <em>Sample 2303 Form:</em>
                          </p>
                          <img 
                            src={twentyThree03} 
                            alt="Sample 2303 Form" 
                            className="sample-photo"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '300px',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              marginTop: '8px'
                            }}
                          />
                        </div>
                      </Form.Group>
                    </>
                  )}

                  {/* Show reason field only when "Not Interested" is selected */}
                  {/* {primaryDetails.non_maya_merchant_type === "Not Interested" && ( */}
                    {/* <Form.Group className="mb-4">
                      <Form.Label className="form-label">
                        If No, state the reason
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="ems"
                        value={primaryDetails.ems || ""}
                        onChange={handleInputChange}
                        placeholder="Short answer text"
                        className="form-input"
                      />
                    </Form.Group> */}
                  {/* )} */}

                  {/* Reason for not Disclosing Monthly Sales
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Reason for not Disclosing Monthly Sales
                    </Form.Label>

                    <div className="form-radio-group">
                      {DISCLOSURE_REASONS.map((option, index) => (
                        <div key={index} className={`form-radio-item ${primaryDetails.monthly_sale_reason === option ? 'selected' : ''}`}>
                          <Form.Check
                            type="radio"
                            name="monthly_sale_reason"
                            value={option}
                            label={option}
                            onChange={handleInputChange}
                            checked={primaryDetails.monthly_sale_reason === option}
                            className="form-radio"
                          />
                        </div>
                      ))}
                    </div>
                  </Form.Group> */}

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NonMayaMerchantInfo;
